/* Mobile product-page conversion improvements — 9 Aug 2026. */
(function () {
  'use strict';

  function moveClipgunExtrasBelowPrimaryAction() {
    if (!window.matchMedia('(max-width: 767px)').matches) return;
    if (window.location.pathname !== '/products/20v-cordless-c-ring-gun') return;

    var addons = document.querySelector('[data-addons]');
    var buy = addons && addons.closest('.buy');
    if (!addons || !buy || addons.getAttribute('data-conversion-moved') === 'true') return;

    if (buy.querySelector('[data-cgp-order]')) return;

    var primary = buy.querySelector('.buy__row');
    if (!primary) return;

    var freightLines = buy.querySelectorAll('.buy__freightline');
    var anchor = freightLines.length ? freightLines[freightLines.length - 1] : primary;

    if (anchor.nextSibling) buy.insertBefore(addons, anchor.nextSibling);
    else buy.appendChild(addons);

    addons.setAttribute('data-conversion-moved', 'true');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', moveClipgunExtrasBelowPrimaryAction);
  } else {
    moveClipgunExtrasBelowPrimaryAction();
  }
})();
